const symbols: Record<string, symbol> = {
  WindowEventManager: Symbol.for('WindowEventManager'),
};

export { symbols };
